export default __webpack_public_path__ + "static/simple-line-b9eb124970df12da0151b5d14cdd3806.png";